// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".-scale-y-100{-webkit-transform:scaleY(-1);transform:scaleY(-1)}", ""]);
// Exports
module.exports = exports;
